import dayjs from 'dayjs';

export const toDataURL = (url: string) => {
  return fetch(url)
    .then(response => {
      return response.blob();
    })
    .then(blob => {
      return URL.createObjectURL(blob);
    });
};

export const downloadFile = async (url: string, fileName?: string) => {
  const a = document.createElement('a');
  a.href = await toDataURL(url);
  a.download = fileName ?? 'download';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const downloadBlob = ({
  blob,
  fileName = 'file',
}: {
  blob: Blob;
  fileName: string;
}) => {
  if (!blob || !window || !document) {
    throw Error('Download failed');
  }

  const blobUrl = window.URL.createObjectURL(
    new Blob([blob], { type: blob.type }),
  );
  const link = document.createElement('a');
  const dateString = dayjs().format('YYYY-MM-DD HH_mm');
  link.href = blobUrl;
  link.setAttribute('download', `${fileName}_${dateString}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};
